<template lang="pug">
.menu-wrapper
  .back-container(v-if="!collapsed" @click="collapseMenu")

  .menu-mobile-bar(v-if="isMobile" :class="{ 'is-hidden': !collapsed }" @click="expandMenuIfCollapsed")
    ul.item-menu-title(v-if="user.logged")
      li.subitem-menu.user-header
        .user-avatar(:class="{ connected: socketConnected }" :title="userFullName")
          | {{ userInitials }}
    ul.item-menu-title(v-else)
      li.subitem-menu.user-header
        router-link(to="/login" @click.native="stopBarClick")
          .user-avatar(title="Iniciar sesión")
    ul.item-menu.capitalize(v-if="user.logged" v-for="shortcut in pinnedShortcutItems" :key="'bar-' + shortcut.id")
      router-link.pointer(:to="shortcut.route" @click.native="stopBarClick")
        .menu-icon-wrapper
          span.material-symbols-outlined.menu-icon {{ shortcut.icon }}
          span.menu-icon-badge(v-if="shortcut.badge" :style="shortcut.badgeStyle") {{ shortcut.badge }}

  .menu-container(
    v-if="!isMobile || !collapsed"
    :class="{ 'is-drawer': isMobile, 'is-collapsed-bar': !isMobile && collapsed, 'is-expanded': !isMobile && !collapsed }"
    @click="expandMenuIfCollapsed"
  )
    .menu(:class="{ collapsed: collapsed && !isMobile }")
      ul.item-menu-title(v-if="user.logged")
        li.subitem-menu.user-header(:class="{ expanded: !collapsed }")
          .user-profile
            .user-avatar(:class="{ connected: socketConnected }" :title="userFullName")
              | {{ userInitials }}
            span.material-symbols-outlined.user-action-icon.logout-icon(v-if="!collapsed" @click="logout") logout
          span.material-symbols-outlined.user-action-icon.settings-icon(v-if="!collapsed" @click="toggleSettings" :class="{ active: showPinSettings }") settings

      ul.item-menu-title(v-else-if="!user.logged")
        li.subitem-menu.user-header(:class="{ expanded: !collapsed }")
          router-link.user-profile(to="/login" @click.native="stopBarClick")
            .user-avatar(title="Iniciar sesión")

      ul.item-menu.capitalize(v-if="user.logged" v-for="menuItem in menuPanelItems" :key="menuItem.isSubItemPin ? 'sub-' + menuItem.route : menuItem.key")
        router-link.pointer(v-if="!menuItem.isSubItemPin" :to="getMenuRoute(menuItem)" @click.native="onPanelItemClick(menuItem, $event)")
          span.material-symbols-outlined.menu-pin(v-if="!collapsed && showPinSettings" @click.stop="togglePin(menuItem.key)" :class="{ active: menu[menuItem.key].pinned }") push_pin
          span.material-symbols-outlined.menu-icon(v-if="!menuItem.badge") {{ menuItem.icon }}
          .menu-icon-wrapper(v-else)
            span.material-symbols-outlined.menu-icon {{ menuItem.icon }}
            span.menu-icon-badge(:style="menuItem.badgeStyle") {{ menuItem.badge }}
          .item-menu-text(v-if="!collapsed") {{ menuItem.label }}
        router-link.pointer(v-else :to="menuItem.route" @click.native="stopBarClick")
          .menu-icon-wrapper
            span.material-symbols-outlined.menu-icon {{ menuItem.icon }}
            span.menu-icon-badge(:style="menuItem.badgeStyle") {{ menuItem.badge }}
          .item-menu-text(v-if="!collapsed") {{ menuItem.subLabel }}
        div(v-if="!menuItem.isSubItemPin && (menu[menuItem.key].show || showPinSettings)")
          li.subitem-menu(v-for="subItem in getSubItemsForDisplay(menuItem)" :key="subItem.route")
            span.material-symbols-outlined.menu-pin.subitem-pin(v-if="showPinSettings" @click.stop="toggleSubItemPin(menuItem.key, subItem)" :class="{ active: isSubItemPinned(menuItem.key, subItem.route) }") push_pin
            router-link.subitem-link(:to="subItem.route") {{ subItem.label }}
</template>

<script>
import mFilter from '@/mixins/filters'
import mConnection from '@/mixins/connection'
import router from '@my/router'

export default {
  name: 'Menu',

  mixins: [mFilter, mConnection],

  data () {
    return {
      isMobile: false,
      menu: {
        metrics: { name: 'metrics', show: false, permmisions: true, pinned: false },
        report: { name: 'report', show: false, permmisions: true, pinned: false },
        tracking: { name: 'tracking', show: false, permmisions: true, pinned: false },
        color: { name: 'color', show: false, permmisions: false, pinned: false },
        set: { name: 'set', show: false, permmisions: false, pinned: false },
        article: { name: 'article', show: false, permmisions: false, pinned: false },
        design: { name: 'design', show: false, permmisions: false, pinned: false },
        code: { name: 'code', show: false, permmisions: false, pinned: false },
        method: { name: 'method', show: false, permmisions: false, pinned: false },
        conveyor: { name: 'conveyor', show: false, permmisions: false, pinned: false },
        location: { name: 'location', show: false, permmisions: false, pinned: false },
        articleDefault: { name: 'articleDefault', show: false, permmisions: false, pinned: false },
        size: { name: 'size', show: false, permmisions: false, pinned: false },
        user: { name: 'user', show: false, permmisions: false, pinned: false },
        product: { name: 'product', show: false, permmisions: false, pinned: false },
        label: { name: 'label', show: false, permmisions: false, pinned: false },
        tier: { name: 'tier', show: false, permmisions: false, pinned: false },
        temporaryStock: { name: 'temporaryStock', show: false, permmisions: false, pinned: false },
        order: { name: 'order', show: false, permmisions: false, new: false, pinned: false },
        delivery: { name: 'delivery', show: false, permmisions: false, new: false, pinned: false },
        refund: { name: 'refund', show: false, permmisions: false, new: false, pinned: false },
        invoice: { name: 'invoice', show: false, permmisions: false, new: false, pinned: false },
        price: { name: 'price', show: false, permmisions: false, pinned: false },
        orderWholesaler: { name: 'orderWholesaler', show: false, permmisions: false, pinned: false },
        orderDropshipping: { name: 'orderDropshipping', show: false, permmisions: false, pinned: false },
        change: { name: 'change', show: false, permmisions: false, pinned: false },
        config: { name: 'config', show: false, permmisions: false, pinned: false },
        image: { name: 'image', show: false, permmisions: false, pinned: false },
        giftVoucher: { name: 'giftVoucher', show: false, permmisions: false, pinned: false },
        giftMessage: { name: 'giftMessage', show: false, permmisions: false, pinned: false },
        bonus: { name: 'bonus', show: false, permmisions: false, pinned: false },
        customer: { name: 'customer', show: false, permmisions: false, pinned: false },
        faq: { name: 'faq', show: false, permmisions: false, pinned: false },
        feedback: { name: 'feedback', show: false, permmisions: false, pinned: false },
        saleDates: { name: 'saleDates', show: false, permmisions: false, pinned: false },
        ecommerceConfig: { name: 'ecommerceConfig', show: false, permmisions: false, pinned: false },
        paymentConfig: { name: 'paymentConfig', show: false, permmisions: false, pinned: false },
        updatePrices: { name: 'updatePrices', show: false, permmisions: false, pinned: false },
        ban: { name: 'ban', show: false, permmisions: false, pinned: false },
        fraudCase: { name: 'fraudCase', show: false, permmisions: false, pinned: false }
      },
      stock: { show: false, permmisions: false },
      print: { show: false, permmisions: true },
      collapsed: false,
      showPinSettings: false,
      pinnedSubItems: [],
      subItemBadgeColors: [
        { bg: '#5C6BC0', color: '#fff' },
        { bg: '#2196F3', color: '#fff' },
        { bg: '#FF9800', color: '#fff' },
        { bg: '#9C27B0', color: '#fff' },
        { bg: '#E91E63', color: '#fff' },
        { bg: '#00BCD4', color: '#fff' },
        { bg: '#795548', color: '#fff' },
        { bg: '#607D8B', color: '#fff' }
      ],
      menuItems: [
        {
          key: 'metrics',
          label: 'Métricas',
          icon: 'insights',
          collapsedRoute: '/metrics',
          subItems: [
            { label: 'General', route: '/metrics' }
          ]
        },
        {
          key: 'report',
          label: 'Reportes',
          icon: 'bar_chart',
          collapsedRoute: '/reports',
          subItems: [
            { label: 'Ventas', route: '/reports/sales' },
            { label: 'Entregas', route: '/reports/deliveries' },
            { label: 'Facturas', route: '/reports/invoices' },
            { label: 'Stock', route: '/reports/stock' }
          ]
        },
        {
          key: 'giftVoucher',
          label: 'Vaca',
          icon: 'card_giftcard',
          collapsedRoute: '/giftVouchers',
          subItems: [
            { label: 'Datos', route: '/giftVouchers' }
          ]
        },
        {
          key: 'giftMessage',
          label: 'Mensajes de Regalo',
          icon: 'mark_unread_chat_alt',
          collapsedRoute: '/giftMessages',
          subItems: [
            { label: 'Datos', route: '/giftMessages' }
          ]
        },
        {
          key: 'bonus',
          label: 'Bonos',
          icon: 'local_offer',
          collapsedRoute: '/bonuses',
          subItems: [
            { label: 'Datos', route: '/bonuses' },
            { label: 'Nuevo', route: '/new-bonus' }
          ]
        },
        {
          key: 'customer',
          label: 'Clientes',
          icon: 'group',
          collapsedRoute: '/customers',
          subItems: [
            { label: 'Datos', route: '/customers' }
          ]
        },
        {
          key: 'order',
          label: 'Orden',
          icon: 'shopping_cart',
          collapsedRoute: '/orders',
          subItems: [
            { label: 'Datos', route: '/orders' },
            { label: 'Empacar', route: '/orders/pack' },
            { label: 'Guías', route: '/orders/guides' },
            { label: 'Novedades', route: '/orders/novelties' }
          ]
        },
        {
          key: 'orderWholesaler',
          label: 'Orden Mayorista',
          icon: 'shopping_bag',
          collapsedRoute: '/orderWholesalers',
          subItems: [
            { label: 'Datos', route: '/orderWholesalers' },
            { label: 'Agregar', route: '/new-orderWholesaler' }
          ]
        },
        {
          key: 'delivery',
          label: 'Entrega',
          icon: 'local_shipping',
          collapsedRoute: '/deliveries',
          subItems: [
            { label: 'Datos', route: '/deliveries' },
            { label: 'Pedidos sin entregar', route: '/deliveries/pending' }
          ]
        },
        {
          key: 'tracking',
          label: 'Seguimiento',
          icon: 'route',
          collapsedRoute: '/others/tracking',
          subItems: [
            { label: 'Datos', route: '/others/tracking' }
          ]
        },
        {
          key: 'refund',
          label: 'Reembolso',
          icon: 'currency_exchange',
          collapsedRoute: '/refunds',
          subItems: [
            { label: 'Datos', route: '/refunds' }
          ]
        },
        {
          key: 'change',
          label: 'Cambios',
          icon: 'swap_horiz',
          collapsedRoute: '/changes',
          subItems: [
            { label: 'Datos', route: '/changes' }
          ]
        },
        {
          key: 'invoice',
          label: 'Factura',
          icon: 'description',
          collapsedRoute: '/invoices',
          subItems: [
            { label: 'Datos', route: '/invoices' },
            { label: 'Individual', route: '/invoice-individual' },
            { label: 'Transportadora', route: '/invoiceConveyor' },
            { label: 'Acuse de recibo DIAN', route: '/invoice-dian-receipt' }
          ]
        },
        {
          key: 'product',
          label: 'Producto',
          icon: 'inventory_2',
          collapsedRoute: '/products',
          subItems: [
            { label: 'Datos', route: '/products' },
            { label: 'Agregar', route: '/new-product' },
            { label: 'Niveles', route: '/find-tier' }
          ]
        },
        {
          key: 'image',
          label: 'Imagen',
          icon: 'image',
          collapsedRoute: '/images',
          subItems: [
            { label: 'Datos', route: '/images' },
            { label: 'Agregar', route: '/new-image' }
          ]
        },
        {
          key: 'temporaryStock',
          label: 'Inventario',
          icon: 'archive',
          collapsedRoute: '/temporaryStocks',
          subItems: [
            { label: 'Datos', route: '/temporaryStocks' },
            { label: 'Agregar', route: '/new-temporaryStock' },
            { label: 'Editar', route: '/inventory/edit' },
            { label: 'Movimientos', route: '/temporaryStock-movements' }
          ]
        },
        {
          key: 'price',
          label: 'Precio',
          icon: 'attach_money',
          collapsedRoute: '/prices',
          subItems: [
            { label: 'Datos', route: '/prices' },
            { label: 'Agregar', route: '/new-price' }
          ]
        },
        {
          key: 'color',
          label: 'Color',
          icon: 'palette',
          collapsedRoute: '/colors',
          subItems: [
            { label: 'Datos', route: '/colors' },
            { label: 'Agregar', route: '/new-color' }
          ]
        },
        {
          key: 'article',
          label: 'Artículo',
          icon: 'description',
          collapsedRoute: '/articles',
          subItems: [
            { label: 'Datos', route: '/articles' },
            { label: 'Agregar', route: '/new-article' }
          ]
        },
        {
          key: 'articleDefault',
          label: 'Predeterminados',
          icon: 'file_copy',
          collapsedRoute: '/articleDefaults',
          subItems: [
            { label: 'Datos', route: '/articleDefaults' },
            { label: 'Agregar', route: '/new-articleDefault' }
          ]
        },
        {
          key: 'design',
          label: 'Diseño',
          icon: 'palette',
          collapsedRoute: '/designs',
          subItems: [
            { label: 'Datos', route: '/designs' },
            { label: 'Agregar', route: '/new-design' }
          ]
        },
        {
          key: 'code',
          label: 'Código',
          icon: 'percent',
          collapsedRoute: '/codes',
          subItems: [
            { label: 'Datos', route: '/codes' },
            { label: 'Agregar', route: '/new-code' }
          ]
        },
        {
          key: 'method',
          label: 'Método',
          icon: 'credit_card',
          collapsedRoute: '/methods',
          subItems: [
            { label: 'Datos', route: '/methods' },
            { label: 'Agregar', route: '/new-method' }
          ]
        },
        {
          key: 'conveyor',
          label: 'Transportadora',
          icon: 'local_shipping',
          collapsedRoute: '/conveyors',
          subItems: [
            { label: 'Datos', route: '/conveyors' },
            { label: 'Agregar', route: '/new-conveyor' }
          ]
        },
        {
          key: 'location',
          label: 'Ubicación',
          icon: 'location_on',
          collapsedRoute: '/locations',
          subItems: [
            { label: 'Datos', route: '/locations' },
            { label: 'Agregar', route: '/new-location' }
          ]
        },
        {
          key: 'size',
          label: 'Talla',
          icon: 'straighten',
          collapsedRoute: '/sizes',
          subItems: [
            { label: 'Datos', route: '/sizes' },
            { label: 'Agregar', route: '/new-size' }
          ]
        },
        {
          key: 'tier',
          label: 'Nivel',
          icon: 'layers',
          collapsedRoute: '/tiers',
          subItems: [
            { label: 'Datos', route: '/tiers' },
            { label: 'Agregar', route: '/new-tier' }
          ]
        },
        {
          key: 'label',
          label: 'Etiqueta',
          icon: 'label',
          collapsedRoute: '/labels',
          subItems: [
            { label: 'Datos', route: '/labels' },
            { label: 'Agregar', route: '/new-label' }
          ]
        },
        {
          key: 'user',
          label: 'Usuario',
          icon: 'person',
          collapsedRoute: '/users',
          subItems: [
            { label: 'Datos', route: '/users' },
            { label: 'Agregar', route: '/new-user' }
          ]
        },
        {
          key: 'config',
          label: 'Configuraciones',
          icon: 'settings',
          collapsedRoute: '/configs',
          subItems: [
            { label: 'Datos', route: '/configs' },
            { label: 'Agregar', route: '/new-config' }
          ]
        },
        {
          key: 'saleDates',
          label: 'Fechas de Venta',
          icon: 'date_range',
          collapsedRoute: '/sale-dates',
          subItems: [
            { label: 'Datos', route: '/sale-dates' }
          ]
        },
        {
          key: 'paymentConfig',
          label: 'Configuración de pagos',
          icon: 'payments',
          collapsedRoute: '/payment-config',
          subItems: [{ label: 'Datos', route: '/payment-config' }]
        },
        {
          key: 'ecommerceConfig',
          label: 'Config Ecommerce',
          icon: 'store',
          collapsedRoute: '/ecommerce-config',
          subItems: [
            { label: 'Datos', route: '/ecommerce-config' }
          ]
        },
        {
          key: 'faq',
          label: 'FAQs',
          icon: 'quiz',
          collapsedRoute: '/faqs',
          subItems: [
            { label: 'Datos', route: '/faqs' }
          ]
        },
        {
          key: 'feedback',
          label: 'Reportes',
          icon: 'rate_review',
          collapsedRoute: '/feedbacks',
          subItems: [
            { label: 'Datos', route: '/feedbacks' },
            { label: 'Agregar', route: '/new-feedback' }
          ]
        },
        {
          key: 'updatePrices',
          label: 'Precios Promoción',
          icon: 'sell',
          collapsedRoute: '/update-prices',
          subItems: [
            { label: 'Datos', route: '/update-prices' }
          ]
        },
        {
          key: 'ban',
          label: 'Baneos',
          icon: 'block',
          collapsedRoute: '/bans',
          subItems: [
            { label: 'Datos', route: '/bans' }
          ]
        },
        {
          key: 'fraudCase',
          label: 'Fraude',
          icon: 'phishing',
          collapsedRoute: '/fraud-cases',
          subItems: [
            { label: 'Activos', route: '/fraud-cases' },
            { label: 'Cerrados', route: '/fraud-cases-closed' },
            { label: 'Informes', route: '/fraud-reports' }
          ]
        }
      ]
    }
  },

  mounted () {
    this.showAccordPermmisions()
    this.loadCollapsedState()
    this.loadPinnedState()
    this.checkMobile()
    window.addEventListener('resize', this.checkMobile)
  },

  beforeDestroy () {
    window.removeEventListener('resize', this.checkMobile)
  },

  methods: {
    checkMobile () {
      this.isMobile = window.innerWidth <= 768
    },

    collapseMenu () {
      if (!this.collapsed) this.toggleCollapsed()
    },

    expandMenuIfCollapsed () {
      if (this.collapsed) this.toggleCollapsed()
    },

    stopBarClick (event) {
      event.stopPropagation()
    },

    onPanelItemClick (menuItem, event) {
      if (this.collapsed) {
        event.stopPropagation()
        return
      }
      this.handleMenuClick(menuItem, event)
    },

    logout () {
      this.$store.commit('logout')
      router.goToHome()
      for (const resolver in this.menu) {
        this.$set(this.menu[resolver], 'permmisions', false)
      }
    },
    toggle (name, normal = true) {
      if (normal) {
        this.menu[name].show = !this.menu[name].show
      } else {
        this[name].show = !this[name].show
      }
    },
    showAccordPermmisions () {
      if (!this.userType) return

      try {
        const permissions = JSON.parse(this.permissionsString)
        const userPermissions = permissions[this.userType] ? permissions[this.userType].permissions : {}

        for (const resolver in this.menu) {
          if (userPermissions[resolver] && userPermissions[resolver].select) this.$set(this.menu[resolver], 'permmisions', true)
        }
      } catch (error) {
        console.log(error)
      }
    },

    changeLanguage (language) {
      this.$store.commit('changeLanguage', language)
    },

    goToData (menuName) {
      // Si está expandido, desplegar submenús
      this.toggle(menuName)
    },

    getMenuRoute (menuItem) {
      if (this.collapsed) {
        return menuItem.collapsedRoute
      }
      if (menuItem.subItems.length === 1 && menuItem.subItems[0].label === 'Datos') {
        return menuItem.subItems[0].route
      }
      return '#'
    },

    handleMenuClick (menuItem, event) {
      if (menuItem.subItems.length === 1 && menuItem.subItems[0].label === 'Datos') {
        return
      }
      this.goToData(menuItem.key)
    },

    loadCollapsedState () {
      const savedState = localStorage.getItem('menuCollapsed')
      if (savedState !== null) {
        this.collapsed = JSON.parse(savedState)
      }
    },

    saveCollapsedState () {
      localStorage.setItem('menuCollapsed', JSON.stringify(this.collapsed))
    },

    toggleCollapsed () {
      this.collapsed = !this.collapsed
      // Si se está colapsando el menú, cerrar todos los submenús y la configuración
      if (this.collapsed) {
        for (const menuItem in this.menu) {
          this.$set(this.menu[menuItem], 'show', false)
        }
        this.showPinSettings = false
      }
      this.saveCollapsedState()
    },

    toggleSettings () {
      this.showPinSettings = !this.showPinSettings
      if (this.showPinSettings) {
        for (const menuItem of this.menuItems) {
          const hasPinableSubItems = menuItem.subItems.some(subItem => subItem.label !== 'Datos')
          if (hasPinableSubItems) {
            this.$set(this.menu[menuItem.key], 'show', true)
          }
        }
      } else {
        for (const menuItem in this.menu) {
          this.$set(this.menu[menuItem], 'show', false)
        }
      }
    },

    getSubItemsForDisplay (menuItem) {
      if (this.showPinSettings) {
        return menuItem.subItems.filter(subItem => subItem.label !== 'Datos')
      }
      return menuItem.subItems
    },

    togglePin (menuName) {
      this.$set(this.menu[menuName], 'pinned', !this.menu[menuName].pinned)
      this.savePinnedState()
    },

    isSubItemPinned (menuKey, route) {
      return this.pinnedSubItems.some(item => item.menuKey === menuKey && item.route === route)
    },

    getSubItemBadge (label) {
      return (label || '').trim().charAt(0).toUpperCase()
    },

    getSubItemColorIndex (menuItem, subItem) {
      const pinableSubItems = menuItem.subItems.filter(item => item.label !== 'Datos')
      const index = pinableSubItems.findIndex(item => item.route === subItem.route)
      return index >= 0 ? index : 0
    },

    getSubItemBadgeStyle (menuItem, subItem) {
      const index = this.getSubItemColorIndex(menuItem, subItem)
      const palette = this.subItemBadgeColors[index % this.subItemBadgeColors.length]
      return {
        backgroundColor: palette.bg,
        color: palette.color,
        borderColor: palette.bg
      }
    },

    buildPinnedSubItemEntry (menuItem, subItem) {
      return {
        ...menuItem,
        isSubItemPin: true,
        route: subItem.route,
        subLabel: subItem.label,
        badge: this.getSubItemBadge(subItem.label),
        badgeStyle: this.getSubItemBadgeStyle(menuItem, subItem)
      }
    },

    toggleSubItemPin (menuKey, subItem) {
      const index = this.pinnedSubItems.findIndex(item => item.menuKey === menuKey && item.route === subItem.route)
      if (index >= 0) {
        this.pinnedSubItems.splice(index, 1)
      } else {
        this.pinnedSubItems.push({
          menuKey,
          route: subItem.route,
          label: subItem.label
        })
      }
      this.savePinnedState()
    },

    loadPinnedState () {
      try {
        const savedPinned = localStorage.getItem('menuPinned')
        if (savedPinned) {
          const pinnedState = JSON.parse(savedPinned)
          for (const menuItem in pinnedState) {
            if (this.menu[menuItem]) {
              this.$set(this.menu[menuItem], 'pinned', pinnedState[menuItem])
            }
          }
        } else {
          const defaultPinned = ['order', 'refund', 'delivery', 'change', 'product']
          defaultPinned.forEach(menuKey => {
            if (this.menu[menuKey]) {
              this.$set(this.menu[menuKey], 'pinned', true)
            }
          })
          this.savePinnedState()
        }

        const savedSubItems = localStorage.getItem('menuPinnedSubItems')
        if (savedSubItems) {
          this.pinnedSubItems = JSON.parse(savedSubItems)
        }
      } catch (error) {
        console.log('Error loading pinned state:', error)
      }
    },

    savePinnedState () {
      try {
        const pinnedState = {}
        for (const menuItem in this.menu) {
          pinnedState[menuItem] = this.menu[menuItem].pinned
        }
        localStorage.setItem('menuPinned', JSON.stringify(pinnedState))
        localStorage.setItem('menuPinnedSubItems', JSON.stringify(this.pinnedSubItems))
      } catch (error) {
        console.log('Error saving pinned state:', error)
      }
    }
  },

  computed: {
    user () {
      return this.$store.state.user
    },
    userInitials () {
      return (this.user.name || '').trim().slice(0, 2).toUpperCase()
    },
    userFullName () {
      return (this.user.name || '')
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ')
    },
    socketConnected () {
      return this.$store.state.socket.socket.connected
    },
    permissionsString () {
      return this.$store.state.variables.permissionsString
    },
    userType () {
      return this.$store.state.user.type
    },
    text () {
      return this.$store.state.languages.language().menu
    },
    currentLanguage () {
      return this.$store.state.languages.currentLanguage
    },
    pinnedShortcutItems () {
      const shortcuts = []

      this.menuItems.forEach(item => {
        if (!this.menu[item.key].permmisions) return

        if (this.menu[item.key].pinned) {
          shortcuts.push({
            id: `menu-${item.key}`,
            icon: item.icon,
            route: item.collapsedRoute
          })
        }

        item.subItems.forEach(subItem => {
          if (!this.isSubItemPinned(item.key, subItem.route)) return
          shortcuts.push({
            id: `sub-${item.key}-${subItem.route}`,
            icon: item.icon,
            route: subItem.route,
            badge: this.getSubItemBadge(subItem.label),
            badgeStyle: this.getSubItemBadgeStyle(item, subItem)
          })
        })
      })

      return shortcuts
    },
    menuPanelItems () {
      if (this.collapsed && !this.isMobile) {
        const items = []

        this.menuItems.forEach(item => {
          if (!this.menu[item.key].permmisions) return

          if (this.menu[item.key].pinned) {
            items.push(item)
          }

          item.subItems.forEach(subItem => {
            if (!this.isSubItemPinned(item.key, subItem.route)) return
            items.push(this.buildPinnedSubItemEntry(item, subItem))
          })
        })

        return items
      }

      return this.menuItems.filter(item => this.menu[item.key].permmisions)
    }
  },

  watch: {
    permissionsString () {
      this.showAccordPermmisions()
    }
  }
}
</script>

<style lang="stylus">
@import '~@/stylus/functions.styl'
@import '~@/stylus/variables.styl'

.menu-wrapper
  position relative
  width 100%
  height 100%
  max-height 100vh
  max-height 100dvh

.menu-container
  height 100%
  max-height 100vh
  max-height 100dvh
  padding .2em 0 .2em .2em
  display flex
  flex-direction column
  background-color var(--background-principal)
  border-right 1px solid rgba(0, 0, 0, 0.2)
  position relative
  overflow hidden
  padding-top 0

.menu-container.is-drawer
  position fixed
  top 0
  left 0
  bottom 0
  height 100vh
  height 100dvh
  max-height 100dvh
  padding-top 0
  z-index 2001
  box-shadow 2px 0 16px rgba(0, 0, 0, 0.15)

.menu-container.is-collapsed-bar
  padding-top 0
  cursor pointer

.menu-container.is-expanded
  position relative
  z-index 2001

.menu-mobile-bar
  display flex
  flex-direction row
  align-items center
  width 100%
  min-height 2.75rem
  padding 0.2em 0.5em
  background-color var(--background-principal)
  border-bottom 1px solid rgba(0, 0, 0, 0.2)
  gap 0 0.75rem
  overflow-x auto
  position relative
  cursor pointer

  &.is-hidden
    visibility hidden
    pointer-events none

  .item-menu-title
    flex-shrink 0
    margin 0

  .item-menu
    flex-shrink 0
    margin 0

  .user-header
    margin 0

  .menu-icon
    margin-right 0
    display inline-block

.menu
  flex 1
  min-height 0
  height auto
  width 20em
  padding 1em
  display flex
  flex-direction column
  overflow-y auto
  overflow-x hidden
  position relative
  z-index 12
  font-weight 500
  text-align left
  gap 1rem 0
  /* Ocultar scrollbar pero permitir scroll */
  scrollbar-width none /* Firefox */
  -ms-overflow-style none /* IE 10+ */
  align-items flex-start

  &::-webkit-scrollbar
    display none /* Chrome/Safari/Webkit */

  .item-menu-title
    width 100%
    align-self stretch
    margin 0
    padding 0
    list-style none
    box-sizing border-box

  .user-header.expanded
    width 100%
    box-sizing border-box

  &.collapsed
    width 4em
    padding 1em

.item-menu
  margin 0
  text-align left
  position relative
  overflow visible

.subitem-link
  padding .3em .5em
  display inline-block
  font-weight 600

  &.router-link-active
    color #5C6BC0

.social-arrow-container
  background-color var(--background-principal)
  position absolute
  top 1.25em
  right -2.3em
  padding 1.1em .7em 1.1em .7em
  borderRadiusCorners(0, .8em, .8em, 0)
  z-index 12

.social-arrow-image
  height 1.8em
  display block
  filter contrast(100%) invert(100%)

.social-arrow-container:hover > a > .social-arrow-image
  opacity 1

.social-arrow-left
  transform rotateZ(180deg)

.show-menu
  left 0
  opacity 1

.back-container
  position fixed
  inset 0
  z-index 2000
  background-color var(--back-container-color)
  cursor pointer

.languages-container
  display flex
  justify-content center
  gap 1em
  margin 2em 0 1em 0

.language-container
  borderRadius(.5em)
  overflow hidden
  opacity .3

.language-container:hover, .current-language
  opacity 1

.language-image
  display block
  width 2.5em

@media print
  .menu
    display none

.menu-icon
  font-size 2em
  margin-right 0.8em
  vertical-align middle
  display inline-block
  color #000
  font-weight 300

  .collapsed &
    margin-right 0
    display block
    text-align center

.item-menu-text
  display inline-block
  vertical-align middle
  font-size 1.15em

  .collapsed &
    display none

.user-avatar
  width 2.1rem
  height 2.1rem
  border-radius 50%
  background-color #f0f0f0
  display flex
  align-items center
  justify-content center
  font-size 0.8rem
  font-weight bold
  color #333
  border 2px solid #ccc
  transition border-color 0.3s ease
  text-transform uppercase

  &.connected
    border-color #4CAF50

  &:not(.connected)
    border-color #f44336

.user-header
  display flex
  align-items center
  gap 0.75rem

  &.expanded
    justify-content space-between
    width 100%

.user-profile
  display flex
  align-items center
  gap 0.5rem

.user-action-icon
  font-size 1.4em
  color #888
  cursor pointer
  transition all 0.2s ease
  padding 0.2rem
  border-radius 0.3rem

  &:hover
    color #4CAF50
    background-color rgba(76, 175, 80, 0.1)

  &.active
    color #4CAF50

  &.settings-icon.active,
  &.settings-icon.active:hover
    background-color transparent

  &.logout-icon:hover
    color #f44336
    background-color rgba(244, 67, 54, 0.1)

.menu-icon-wrapper
  position relative
  display inline-block
  vertical-align middle
  font-size 2em
  overflow visible

  .menu-icon
    margin-right 0
    font-size 1em

  .collapsed &
    display block

.menu-icon-badge
  position absolute
  bottom -0.3rem
  right -0.5em
  display flex
  align-items center
  justify-content center
  width 1.2rem
  height 1.2rem
  padding 0
  font-size .7rem
  text-align center
  background-color #ffffff
  color #000000
  border-radius 50%
  font-weight 700
  font-family inherit
  box-sizing border-box
  border 1px solid #000000
  overflow visible

  .menu-mobile-bar &
    right -0.18em
    bottom -0.02em

.menu-pin
  position relative
  font-size 1em
  color #ccc
  cursor pointer
  transition all 0.2s ease
  opacity 0.7
  margin-right 0.5rem

  &:hover
    opacity 1
    color #888

  &.active
    color #4CAF50
    opacity 1

.subitem-pin
  font-size 0.85em
  margin-right 0.35rem
  vertical-align middle

  &.active
    color #5C6BC0
    opacity 1
</style>



// WEBPACK FOOTER //
// src/components/layout/Menu.vue